import { lazy, Suspense, useEffect, useMemo, useState } from "react"
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"
import { Layout, Spin } from "antd"

import type { EstruturaRotasCompleta } from "./types" // Removi Rota se não estiver usando explicitamente aqui
import { carregarPagina } from "./paginas/paginasLoader"
import { menuService } from "./services/menuService"

import MenuComponent from "./components/menuComponent"
import RodapeComponent from "./components/RodapeComponent"
import "antd/dist/reset.css"; 
import "./App.css"

const { Content } = Layout;

// --- 1. IMPORTAÇÃO LAZY DA NOVA PÁGINA ---
// Isso garante que o código da página de detalhes só baixe quando necessário
const DetalhesProduto = lazy(() => import("./paginas/DetalhesProduto"));

// Componente de fallback para o Suspense
const PaginaCarregando = () => (
  <div className="suspense-fallback">
    <Spin size="large" />
  </div>
);

function App() {
  const [estruturaCompleta, setEstruturaCompleta] = useState<EstruturaRotasCompleta | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    menuService
      .getRotasDinamicas()
      .then((estrutura) => {
        setEstruturaCompleta(estrutura)
      })
      .catch((err) => {
        console.error("Erro ao carregar estrutura de rotas:", err)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  const rotasDinamicas = useMemo(() => {
    if (!estruturaCompleta) return [];

    return estruturaCompleta.routes.map((rota) => {
      const ComponenteLazy = lazy(() => carregarPagina(rota.pagina_tsx));

      return (
        <Route
          key={rota.path}
          path={rota.path}
          element={<ComponenteLazy />}
        />
      );
    });
  }, [estruturaCompleta]);

  if (loading) {
    return (
      <div className="app-loading">
        <p>Carregando aplicação...</p>
      </div>
    )
  }

  return (
    <BrowserRouter>
      <Layout className="layout">
        <MenuComponent estruturaCompleta={estruturaCompleta} />
        <Content className="content" style={{ marginTop: 64, minHeight: 'calc(100vh - 64px)' }}>  <Suspense fallback={<PaginaCarregando />}>
            <Routes>
              {/* Rotas carregadas do banco de dados */}
              {rotasDinamicas}

              {/* --- 2. NOVA ROTA ESTÁTICA --- */}
              {/* Esta rota precisa estar aqui manualmente pois não vem do menu dinâmico */}
              <Route path="/produto/:id" element={<DetalhesProduto />} />

              {/* Rota de Catch-all (Redirecionamento) */}
              <Route path="*" element={<Navigate to="/home" replace />} />
            </Routes>
          </Suspense>
        </Content>
        <RodapeComponent />
      </Layout>
    </BrowserRouter>
  )
}

export default App